"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "xhrCall", {
    enumerable: true,
    get: function() {
        return xhrCall;
    }
});
var XMLHTTPREQUEST_DONE = typeof XMLHttpRequest.DONE !== "undefined" ? XMLHttpRequest.DONE : 4;
var xhrCall = function(options, callback) {
    var method = options.method, url = options.url, _options_payload = options.payload, payload = _options_payload === void 0 ? {} : _options_payload, _options_withCredentials = options.withCredentials, withCredentials = _options_withCredentials === void 0 ? false : _options_withCredentials;
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.withCredentials = withCredentials;
    xmlhttp.open(method, url);
    xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xmlhttp.send(JSON.stringify(payload));
    xmlhttp.onreadystatechange = function onreadystatechange() {
        if (xmlhttp.readyState === XMLHTTPREQUEST_DONE && callback) {
            if (xmlhttp.status === 200) {
                callback();
            } else {
                callback(xmlhttp.responseText);
            }
        }
    };
};

//# sourceMappingURL=apiCallFunctions.js.map